import { render } from "./TraineeSignature.vue?vue&type=template&id=bb5d9488&scoped=true"
import script from "./TraineeSignature.vue?vue&type=script&lang=js"
export * from "./TraineeSignature.vue?vue&type=script&lang=js"

import "./TraineeSignature.vue?vue&type=style&index=0&id=bb5d9488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb5d9488"]])

export default __exports__